module.exports = __webpack_public_path__ + "img/plus.7292414a.svg";